<app-single-select-dropdown
	[opties]="schooljaarOptions()"
	[selectedOptie]="selectedJaarOption()"
	(onOptieClicked)="selectJaarOption($event)"
>
</app-single-select-dropdown>
